import { Button, Flex, Text } from '@mantine/core';
import { createUserNameColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/UserColumn';
import type { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import type { OrganizationDefaultMemberRes } from '@dealstack/shared/lib/backendClient';
import type { DefaultMemberTableLabels } from '@dealstack/frontend/app/pages/Organization/OrganizationDefaultMembers/OrganizationDefaultMembers.types';

export const buildDefaultMemberColumns = ({
	labels,
	roleLabel,
	onRemove,
	isRemoving,
}: {
	labels: DefaultMemberTableLabels;
	roleLabel: (role: string) => string;
	onRemove: (userId: string) => void;
	isRemoving: boolean;
}): ExtendedColumnDef<OrganizationDefaultMemberRes>[] => [
	createUserNameColumn<OrganizationDefaultMemberRes>({
		header: labels.name,
		filterPlaceholder: labels.search,
		filterText: labels.search,
	}),
	{
		accessorKey: 'permissionRole',
		header: labels.role,
		cell: ({ row }) => <Text size="B6Medium">{roleLabel(row.original.permissionRole)}</Text>,
	},
	{
		id: 'actions',
		header: '',
		size: 200,
		minSize: 200,
		cell: ({ row }) => (
			<Flex justify="flex-end">
				<Button
					variant="subtle"
					color="red"
					style={{ flexShrink: 0 }}
					disabled={isRemoving}
					onClick={() => onRemove(row.original.userId)}
				>
					{labels.remove}
				</Button>
			</Flex>
		),
	},
];
